<template>
  <div id="app" class="crm-app">
    <!-- 顶部组件 -->
    <TopBar />
    
    <div class="main-container">
      <!-- 左侧边栏 -->
      <SideBar :activeModule="activeModule" @changeModule="changeModule" />
      
      <!-- 右侧页面内容 -->
      <PageContent :activeModule="activeModule" />
    </div>
  </div>
</template>

<script>
import TopBar from './components/TopBar.vue'
import SideBar from './components/SideBar.vue'
import PageContent from './components/PageContent.vue'

export default {
  name: 'CRM',
  components: {
    TopBar,
    SideBar,
    PageContent
  },
  data() {
    return {
      activeModule: 'CrmDashboard' // 默认首页大屏
    }
  },
  methods: {
    changeModule(module) {
      this.activeModule = module
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.crm-app {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #0a1f0f;
}

.main-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}
</style>